export default {
  taskColumns: [
    {label: '任务ID', prop: 'APPLY_ID', width: 80},
    {label: '操作类型', prop: 'Scan_Type', width: 80, format: 'showScanType'},
    {label: '需求数量', prop: 'TaskNum', width: 80},
    {label: '已操作数量', prop: 'AlreadyOperatedNum', width: 80},
    {label: '最后一次上传的扫描时间', prop: 'LastUploadTime', width: 150},
    {label: '任务目标网点', prop: 'SITE_NAME'},
    {label: '袋子类型', prop: 'PACKAGE_TYPE', width: 120, format: 'showPackageType'},
    {label: '发放类型', prop: 'BUSINESS_TYPE', width: 120, format: 'showBusinessType'},
  ],
  listColumns: [
    {label: '环保袋id', prop: 'rfid'},
    {label: '操作类型', prop: 'scanType'},
    {label: '目标网点', prop: 'relationSiteName'},
    {label: '任务ID', prop: 'taskId'},
    {label: '采集时间', prop: 'scanTime'},
    {label: '采集设备', prop: 'cjsbid'},
    {label: '采集网点', prop: 'scanSite'},
  ],
  inLabels: [
    {label: '新袋入库', scanType: '12', taskId: '2'},
    {label: '调拨入库', scanType: '13', taskId: '3'},
    {label: '拆袋入库', scanType: '14', taskId: '4'},
    {label: '进港退库', scanType: '60', taskId: '7'},
    {label: '维修出库', scanType: '40', taskId: '11'},
    {label: '维修后入库', scanType: '48', taskId: '13'},
  ],
  allScanTypes: [
    {label: '拆袋入库', value: '14'},
    {label: '调拨入库', value: '13'},
    {label: '新袋入库', value: '12'},
    {label: '维修工厂入库', value: '44'},
    {label: '维修后入库', value: '48'},
    {label: '进港退库', value: '60'},
    {label: '出港发放', value: '22'},
    {label: '调拨', value: '23'},
    {label: '维修发放', value: '24'},
    {label: '进港发放', value: '25'},
    {label: '维修出库', value: '40'},
  ],
  allPackageTypes: [
    {label: '普通', value: '1'},
    {label: '文件', value: '3'},
    {label: 'Vip', value: '4'},
    {label: '循环箱', value: '5'},
  ],
  outboundTypes: [
    {label: '出港发放', value: '0'},
    {label: '维修发放', value: '2'},
    {label: '进港发放', value: '1'},
  ],
  heapSelectColumns: [
    {label: '堆号', prop: 'u_name', width: 80},
    {label: '录入数量', prop: 'u_Count', width: 80},
    {label: '堆容量', prop: 'u_MaxCount', width: 80},
  ]
}
